
interface ConfigData {
     demoEnabled: boolean;
     basePath: string;
     apiBaseURL: string;
     fidusVisionURL: string;
     enrollmentsURL: string;
     storesURL: string;
     trafficAnalyticsURL: string;
     defaultZone: string;
     sessionInfoURL: string;
     loadData: string;
     auditReportsBaseURL: string;
}

function getConfig(): ConfigData {
     console.log('ENV:' + process.env.NODE_ENV);
     const jsonConfig = (window as any).Config;
     let conf = {};
     switch (process.env.NODE_ENV) {
          case 'development':
               conf = jsonConfig.development;
               break;
          case 'production':
               conf = jsonConfig.production;
               break;
          default:
               conf = jsonConfig.demo;
     }
     return conf as ConfigData;
}

const Config: ConfigData = getConfig();

export default Config;